import Vue from 'vue'
import {mapGetters} from 'vuex'
Vue.use({
    install() {
        Vue.prototype.$loginCallback = function () {
            if(this.$route.query._token)
            {
                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: this.$route.query._token,
                    remember: true
                })

                // Fetch the user.
                this.$store.dispatch('auth/fetchUser')

            }

            // if(this.$route.query.newsub)
            //     localStorage.setItem('newsub', true)

            if(this.$route.query.hasOwnProperty('error_n'))
            {
                window.location.href = `/desporto?error_no=${this.$route.query.error_n}&message=${this.$route.query.message}`;
            }

            if(this.$route.query.hasOwnProperty('error_no'))
            {
                this.$q.notify({
                    color: 'warning',
                    icon: 'warning',
                    message: this.$T(this.$route.query.message),
                    detail: "",
                    position: 'top',
                    timeout: 5000,
                })
            }

            if(this.$route.query.newsub)
                this.$router.replace({query:{}});
        }
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/loginCallback.js